











































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import axios from "axios";
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import {Editor} from '@toast-ui/vue-editor';
// eslint-disable-next-line no-unused-vars
import Template from "@/model/Template";
import EditorHelper from "@/components/EditorHelper.vue";

@Component({
  components: {Editor, EditorHelper}
})
export default class EditTemplateDialog extends Vue {
  $refs!: {
    form: HTMLFormElement
    toastuiEditor: HTMLFormElement
  }
  orderStatuses = [
    {text: "Venter varer inn", value: "EXPECTED"},
    {text: "Leveringsutsettelse", value: "DELAYED"},
    {text: "Varer utgått og utsolgt", value: "DISCONTINUED"},
    {text: "Klar til plukk", value: "READY_FOR_PICKING"},
    {text: "Må følges opp", value: "NEEDS_FOLLOWUP"}
  ]
  editorOptions = {
    hideModeSwitch: true,
    toolbarItems: [
      'heading',
      'bold',
      'italic',
      'strike',
      'divider',
      'hr',
      'quote',
      'divider',
      'ul',
      'ol',
      'task',
      'indent',
      'outdent',
      'divider',
      'table',
      'image',
      'link',
      'divider',
      'code',
      'codeblock'
    ]

  }
  isValid = true
  requiredRule: any = (v: any) => !!v || 'Påkrevd'

  @Prop({required: true})
  visible!: boolean

  @Prop({required: true})
  template: Template

  get computedVisible() {
    return this.visible
  }

  set computedVisible(visible) {
    if (!visible) {
      this.resetAndClose()
    }
  }

  public resetAndClose() {
    this.$refs.form.reset()
    this.$emit('closed')
  }

  public saveTemplate() {
    this.template.body = this.$refs.toastuiEditor.invoke('getHtml')
    axios.put('/api/templates', this.template).then(() => {
      this.resetAndClose()
    })
  }

  @Watch('visible')
  onVisibleChanged(visible: boolean) {
    if (visible) {
      this.$nextTick(() => {
        this.$refs.toastuiEditor.invoke('setHtml', this.template.body);
      })

    }
  }

}

